/**
 * @file 开发者社区 功能简介（我也不知道怎么描述）
 * @author WanZhongYun(wanzhongyun@baidu.com)
 */
import React from 'react';
import { IPreviewData } from './../../types';

import './style.less';

const DeveloperPreView: React.FC<IPreviewData> = props => {
    const { list = [] } = props;
    return (
        <div className="developer-community-preview-wrapper">
            <div className="developer-community-preview">
                {
                    list.map(item => <div className="preview-item-card" key={item.title}>
                        <a href={item.link}><div className="preview-title">{item.title}</div></a>
                        <div className="preview-content">{item.text}</div>
                    </div>)
                }
            </div>
        </div>
    );
};

export default DeveloperPreView;